import { useHandler } from "@redotech/react-util/hook";
import { RedoFeatureNotificationCard } from "@redotech/redo-web/arbiter-components/feature-notification/redo-feature-notification-card";
import { memo, useContext } from "react";
import { MarketingModalContext } from "../../redo-marketing/marketing-modal-context";
import { OnboardingProps } from "../common";

export const RedoCommentsold = memo(function RedoCommentsold({
  handleDismiss,
  handleComplete,
}: OnboardingProps) {
  const marketingModal = useContext(MarketingModalContext);

  const handleAction = useHandler(() => {
    marketingModal.openModal("commentsold");
    handleComplete();
  });

  return (
    <RedoFeatureNotificationCard
      actionText="Learn more"
      description="We’ve partnered with CommentSold to help you grow faster! Their all-in-one platform includes a branded mobile app, live selling, and social integrations to save you time while increasing revenue."
      image="https://assets.getredo.com/redo-suite/cs-redo.jpg"
      onAction={handleAction}
      onDismiss={handleDismiss}
      title="Keep your best customers just a tap away."
    />
  );
});
